import { LucideIcon } from "lucide-react";
import React from "react";

type StatCardProps = {
  title: string;
  value: string;
  icon: LucideIcon;
  iconBg: string;
  iconColor?: string;
  trend?: {
    value: string;
    isPositive?: boolean;
  };
};

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  iconBg,
  iconColor = "",
  trend,
}) => {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 flex flex-col justify-between">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold text-gray-400 tracking-wide uppercase">
            {title}
          </p>

          <h2 className="text-xl font-extrabold text-gray-800 mt-1.5 tracking-tight truncate">
            {value}
          </h2>
        </div>

        <div
          className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${iconBg}`}
        >
          <Icon size={22} className={iconColor} />
        </div>
      </div>

      {trend && (
        <div className="mt-3 pt-2.5 border-t border-gray-50 flex items-center gap-1.5">
          <span
            className={`text-xs font-bold ${
              trend.isPositive ? "text-emerald-600" : "text-rose-600"
            }`}
          >
            {trend.isPositive ? "+" : ""}
            {trend.value}
          </span>
          <span className="text-[11px] text-gray-400">vs last period</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;